export function getDateTime(dateString, formatDate = 'y-m-d') {
    let separator = '-';
    const [dateStr, timeStr] = dateString.split(' ');
    if(formatDate === 'd.m.y'){
        separator = '.';
    }
    const [year, month, day] = dateStr.split(separator);
    const [hours, minutes, seconds] = timeStr.split(':');
    return new Date(year, month - 1, day, hours, minutes, seconds);
}
